export default __webpack_public_path__ + "static/media/anodizing-icon-dark.b2741f38.svg";